var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRehberlikVideolari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_1686_765)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_765)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40901 7.40901C7.83097 6.98705 8.40326 6.75 9 6.75H18.75C19.3467 6.75 19.919 6.98705 20.341 7.40901C20.7629 7.83097 21 8.40326 21 9V14.25C21 14.6642 20.6642 15 20.25 15C19.8358 15 19.5 14.6642 19.5 14.25V9C19.5 8.80109 19.421 8.61032 19.2803 8.46967C19.1397 8.32902 18.9489 8.25 18.75 8.25H9C8.80109 8.25 8.61032 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V18.75C8.25 18.9489 8.32902 19.1397 8.46967 19.2803C8.61032 19.421 8.80109 19.5 9 19.5H14.25C14.6642 19.5 15 19.8358 15 20.25C15 20.6642 14.6642 21 14.25 21H9C8.40326 21 7.83097 20.7629 7.40901 20.341C6.98705 19.919 6.75 19.3467 6.75 18.75V9C6.75 8.40326 6.98705 7.83097 7.40901 7.40901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4697 14.4697C14.6846 14.2548 15.0079 14.1908 15.2884 14.3077L22.7884 17.4322C23.0764 17.5522 23.2601 17.8379 23.2496 18.1497C23.2391 18.4616 23.0367 18.7343 22.7412 18.8347L19.8257 19.825L18.8346 22.7413C18.7342 23.0367 18.4615 23.2391 18.1497 23.2496C17.8379 23.2601 17.5522 23.0764 17.4322 22.7884L14.3077 15.2884C14.1908 15.0079 14.2548 14.6846 14.4697 14.4697ZM16.3927 16.3927L18.0533 20.3788L18.5244 18.9924C18.5994 18.7718 18.7726 18.5986 18.9933 18.5236L20.3784 18.0531L16.3927 16.3927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9697 18.9697C19.2626 18.6768 19.7374 18.6768 20.0303 18.9697L22.2803 21.2197C22.5732 21.5126 22.5732 21.9874 22.2803 22.2803C21.9874 22.5732 21.5126 22.5732 21.2197 22.2803L18.9697 20.0303C18.6768 19.7374 18.6768 19.2626 18.9697 18.9697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_765",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CCCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B4D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehberlikVideolari);
export default __webpack_public_path__ + "static/media/rehberlik-videolari.95c7b18c607c78ad63d889cbb0b242b5.svg";
export { ForwardRef as ReactComponent };